const navLinks = [
  { label: "Capabilities", href: "#capabilities" },
  { label: "Process", href: "#showcase" },
  { label: "Contact", href: "#contact" },
];

export default function Footer() {
  const scrollTo = (href) => {
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="footer" className="relative border-t border-white/[0.04]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-14 md:py-16">
        <div className="flex flex-col items-center md:flex-row md:items-center justify-between gap-10 text-center md:text-left">
          <span className="font-heading text-xs tracking-[0.35em] uppercase inline-flex pop-click">
            <span className="text-white/60">D</span>
            <span style={{ backgroundImage: "linear-gradient(135deg, #C49B3C, #F5D77A, #A67C28)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>E</span>
            <span style={{ backgroundImage: "linear-gradient(135deg, #00E5FF, #7A5CFF)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>V</span>
            <span style={{ backgroundImage: "linear-gradient(135deg, #7A5CFF, #FF2D9A)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>A</span>
            <span className="text-white/60">MIND&nbsp;AI</span>
          </span>

          <a
            href="mailto:hello@devamind.in"
            data-testid="footer-email-link"
            className="font-mono text-[10px] tracking-[0.15em] text-white/50 hover:text-[#00E5FF] transition-colors duration-700 pop-click"
          >
            hello@devamind.in
          </a>

          <div className="flex items-center gap-8">
            {navLinks.map((link) => (
              <button
                key={link.label}
                data-testid={`footer-link-${link.label.toLowerCase()}`}
                onClick={() => scrollTo(link.href)}
                className="font-mono text-[9px] tracking-[0.2em] uppercase text-white/45 hover:text-[#00E5FF] transition-colors duration-500 pop-click"
              >
                {link.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/[0.03]">
          <p className="font-mono text-[9px] tracking-[0.15em] text-zinc-600 text-center md:text-left pop-click">
            &copy; {new Date().getFullYear()} Devamind AI Pvt. Ltd. All systems operational.
          </p>
        </div>
      </div>
    </footer>
  );
}
